module.exports = __webpack_public_path__ + "img/checkpass2.b00fe28e.png";